import { boot } from "quasar/wrappers";

import { useCommonStore } from "src/stores/common-store";
import { usePersistedStore } from "src/stores/persisted-store";
import { useVersionUpdateStore } from "src/stores/versionupdate-store";
import { Platform } from "quasar";
import { checkForUpdatedVersion, decodeJwtToken } from "src/utils";
import { getAccountID } from "src/utils/commonFunction";
import firebase from "firebase/app";
import "firebase/auth";
import { identityAxiosInstance, setidentityAxiosHeaders } from "./axios";
import { useUserInfo } from "src/stores/user-store";
import { sendMessageToParentApp } from "src/utils";
import LogRocket from "logrocket";

const userStore = useUserInfo();

export default boot(({ app, router, store }) => {
  router.beforeEach(async (to, from, next) => {
    //here need to code first
    const commonStore = useCommonStore(store);
    let persistedStore = usePersistedStore();
    let appLoaded = commonStore.appLoaded;
    // if (to.name != "Callback") {
    //   await persistedStore.mapUser()
    // }
    //remove search keyword from store so it becomes empty on other page

    if (commonStore.searchKeyword) commonStore.updateSearchkeyword("");
    commonStore.toggleHeaderSearch(false);

    if (!appLoaded) {
      commonStore.setLoader(true);
      await commonStore.mapInIframe();
      persistedStore.getToken(); //to set the token
      await persistedStore.mapUser();
      ////~~~~Check User~~~~~/////
      await userStore.checkUserInLNS();
      await commonStore.getStoreConfiguration();
      if (persistedStore?.user && persistedStore?.user?.access_token) {
        await userStore.getUserDetails();
        await commonStore.getAlMyStores();
      }
      commonStore.setAppLoaded(true);
    }

    if (
      to.name != "NewLogin" &&
      to.name != "AgeVerification" &&
      !to.meta.showWithoutLogin &&
      (!persistedStore.user || !persistedStore.user.access_token) &&
      to.name != "Callback"
    ) {
      next({ name: "NewLogin" });
      // next({ name: "Login" });
    } else if (!userStore.userInLns && to.name != "AccountLinked") {
      next({ name: "AccountLinked" });
    } else {
      commonStore.showInstallAppBanner = false;
      if (commonStore.initialPage && commonStore.appInIframe) {
        next(commonStore.initialPage);
        commonStore.initialPage = null;
      } else next();
    }
    commonStore.setLoader(false);

    if (to?.fullPath && commonStore.appInIframe)
      sendMessageToParentApp({
        action: appLoaded ? "NAVIGATION" : "ROUTE_REPLACE",
        value: to.fullPath,
      });
  });

  router.afterEach(async (routeTo, routeFrom) => {
    const commonStore = useCommonStore(store);
    // Optional: Track page views with the router
    // LogRocket.log("Page view", routeTo.fullPath);
    if (Platform.is?.mobile) {
      commonStore.setHeader(
        routeTo.meta.header?.account && getAccountID()
          ? routeTo.meta.header.account
          : routeTo.meta.header
      );
    }

    // For Global search
    if (routeTo.name == "Home") {
      commonStore.resetGlobalSearchData();
      commonStore.toggleGlobalSearch({
        showGlobalSearch: false,
        searchText: "",
      });
    }

    //switch off the loader
    if (commonStore.showFullScreenLoader) commonStore.setLoader(false);

    //set route histories
    if (routeTo.name != routeFrom.name && routeFrom.name) {
      let backRoute = commonStore.getBackRoute;
      if (
        (commonStore.isBackEvent && routeTo.meta.clearHistory) ||
        commonStore.blnClearHistory
      ) {
        commonStore.clearAllHistory();
      } else if (backRoute && backRoute.name == routeTo.name) {
        commonStore.popFromHistory();
      } else if (!routeFrom.meta.disableHistory) {
        commonStore.addInHistory(routeFrom);
      }
    }
  });
});
